var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import { ShuttersComponent } from './ShuttersComponent';
import RadioImageButton from '@declaration/components/UI/RadioImageButton.vue';
import { SHUTTER_SUBTITLE, SHUTTER_TITLE, SHUTTER_TYPE_CHOICES, } from '@declaration/constants/externalDamages';
let ShuttersType = class ShuttersType extends ShuttersComponent {
    get title() {
        return this.translateExternalDamageKey(SHUTTER_TITLE);
    }
    get subtitle() {
        return this.translateExternalDamageKey(SHUTTER_SUBTITLE);
    }
    get shutterTypeChoices() {
        return SHUTTER_TYPE_CHOICES;
    }
};
ShuttersType = __decorate([
    Component({ components: { RadioImageButton } })
], ShuttersType);
export default ShuttersType;
